import {Component, forwardRef, Inject, Injector, Input, OnInit} from "@angular/core";
import {NgbActiveModal} from "@ng-bootstrap/ng-bootstrap";
import {TranslateService} from "@ngx-translate/core";
import {AlertService} from "../services/alert.service";
import {ClientService} from "../services/client.service";
import {DomSanitizer} from "@angular/platform-browser";
import {SessionService} from "../services/session.service";
import {ModalResult} from "../model/common.model";
// import {authenticator} from "otplib";
//import otplib from 'otplib';
//import { authenticator } from 'otplib/otplib-browser';

@Component({
  templateUrl: 'DlgAskOTP.html'
})
export class DlgAskOTP  implements OnInit {
  @Input() loading = false;

  otp: string;


  constructor(public activeModal: NgbActiveModal, private injector: Injector,
              @Inject(forwardRef(() => AlertService)) private alertService: AlertService,
              @Inject(forwardRef(() => ClientService)) private clientService: ClientService,
              @Inject(forwardRef(() => DomSanitizer)) private domSanitizer: DomSanitizer,
              @Inject(forwardRef(() => SessionService)) private session: SessionService,
              @Inject(forwardRef(() => TranslateService)) private translate: TranslateService) {

  }


  ngOnInit() {


  }



  onValidateKeyPressed(event) {
    if (event.keyCode === 13) {
      this.onValidate();
    }
    // console.log('KeyPressed: ' + event.keyCode + ' ' + event.keyIdentifier);
  }



  onValidate(){
    this.activeModal.close(this.otp);
  }

  onCancel() {
    this.activeModal.close(ModalResult.CANCEL);
  }

}
